import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

const LoadingComponent = f => {
  return (
    <div style={{textAlign:'center'}}><i className="fa fa-spinner fa-spin fa-2x"></i></div>
  )
}

const LoadableComponent = opts => {
  return Loadable({
    delay: 300,
    LoadingComponent,
    ...opts,
  })
}

const ImportLoadableComponent = (loader, webpackRequireWeakId) => {
  const Component = LoadableComponent({
    loader,
    // webpackRequireWeakId
  });

  return Component;
}

export default LoadableComponent;

export const ImportLoadable = ImportLoadableComponent;



// WEBPACK FOOTER //
// ./src/browser/components/ui/loadable-component.js